import React from "react";
import { CircleCheckBigIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CtaButtonProps = {
  label: string;
  id?: string;
};
export function CtaButton({
  label,
  id
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className="animate-cta-pulse group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[1.05rem] font-extrabold uppercase leading-tight tracking-wide text-white transition-[background-color,transform] duration-150 ease-out hover:bg-ctadark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-xl" data-id="element-29" data-mp="hlgn9odcwtkk">
      <CircleCheckBigIcon className="h-7 w-7 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-30" data-mp="vbac46ov3dua" />
      <span data-id="element-31" data-mp="vdmsifez1g58">{label}</span>
    </a>;
}